// @ts-check

import { api } from '@/api'
import * as _ from 'lodash-es'

/**
 * @returns {Promise<import('axios').AxiosResponse<BankTransactions> & { meta: any}>}
 */
export function getBankTransactions(params, page) {
  const requestBody = { params: { ...params } }

  if (page) {
    requestBody.params = Object.assign(requestBody.params, { page })
  }

  if (_.has(requestBody.params, 'search')) {
    requestBody.params.search = encodeURI(requestBody.params.search)
  }

  return api.get(`bank-transactions`, requestBody)
}

/**
 * @param {string} type
 * @param {BankTransactions} bankTransactions
 * @returns
 */
export async function createEntryFromBankTransactions(
  type,
  bankTransactions,
  amount,
  isPrivate,
  description
) {
  if (amount && bankTransactions.length === 1) {
    bankTransactions = [{ ...bankTransactions[0], amount }]
  }

  const payload = {
    type,
    bank_transactions: bankTransactions,
    is_private: isPrivate
  }

  if (description) {
    payload.description = description
  }

  if (isPrivate) {
    const transactionsByBookingDate = _.groupBy(
      bankTransactions,
      (transaction) => transaction.booking_date
    )
    return Promise.all(
      Object.values(transactionsByBookingDate).map((transactions) =>
        api.post('bank-transactions/create/entry', {
          ...payload,
          bank_transactions: transactions
        })
      )
    )
  }

  return api.post('bank-transactions/create/entry', payload)
}

export function removeBankTransaction(id, removalReason) {
  return api.post(`bank-transactions/${id}/remove`, {
    removal_reason: removalReason
  })
}

/**
 *
 * @param {BankTransactionResource} bankTransaction
 */
export const cancelBankTransaction = ({ id: bankTransactionId }) =>
  api.post(`/bank-transactions/${bankTransactionId}/cancel`)

/**
 * @param {BankTransactionResource['id']} bankTransactionId
 * @returns {Promise<BankTransactionResource>}
 */
export const getBankTransaction = async (bankTransactionId) =>
  (await api.get(`/bank-transactions/${bankTransactionId}`)).data

/**
 * @param {BankTransactionResource['id']} bankTransactionId
 * @returns {Promise<BankTransactionLinkedPayments>}
 */
export const getBankTransactionLinkedPayments = async (bankTransactionId) =>
  (await api.get(`/bank-transactions/${bankTransactionId}/linked-payments`))
    .data
